<div class="audio-player d-flex justify-content-center">
    <button class="close_btn" (click)="closeAudio()" [matTooltip]="'general.close'|translate">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path id="ic_close"
                d="M213.746-744.393l-6.441,6.436a1.459,1.459,0,0,1-1.063.457,1.406,1.406,0,0,1-1.046-.457,1.418,1.418,0,0,1-.45-1.054,1.449,1.449,0,0,1,.45-1.037l6.441-6.452-6.441-6.452a1.419,1.419,0,0,1-.441-1.037,1.473,1.473,0,0,1,.441-1.053,1.406,1.406,0,0,1,1.046-.457,1.485,1.485,0,0,1,1.063.441l6.441,6.452,6.458-6.452a1.431,1.431,0,0,1,1.046-.441,1.458,1.458,0,0,1,1.063.457,1.443,1.443,0,0,1,.433,1.053,1.448,1.448,0,0,1-.45,1.037l-6.441,6.452,6.441,6.452a1.419,1.419,0,0,1,.441,1.037,1.473,1.473,0,0,1-.441,1.054,1.406,1.406,0,0,1-1.046.457,1.406,1.406,0,0,1-1.046-.457Z"
                transform="translate(-204.746 755.5)" fill="#999" />
        </svg>
    </button>
    <div class="d-flex align-items-center justify-content-center flex-wrap">
        <div class="audio-info">
            <div class="image">
                <img *ngIf="thumbnail" [src]="thumbnail" (error)="thumbnail = ''" alt="cover Image">
                <img *ngIf="!thumbnail" class="defualt-image" [src]="'./assets/images/icons/ic_audio.png'"
                    alt="cover Image">
            </div>
            <h4>
                {{title}}
            </h4>
        </div>
        <div class="audio-volume">
            <mat-slider aria-label="unit(s)" [disabled]="isMuted" [(ngModel)]="volume" (ngModelChange)="changeVolume()"
                step="0.01" min="0" max="1"></mat-slider>
            <button (click)="toggleMute()" [class.muted]="isMuted">
                <img src="./assets/images/icons/ic_speaker.svg" alt="ic_speaker">
            </button>
        </div>
        <div class="audio-bar">
            <span>{{ formatTime(currentTime) }}</span>
            <mat-slider [(ngModel)]="progress" step="0.00001" [min]="0" [max]="1"
                (ngModelChange)="seekAudio($event)"></mat-slider>
            <span>{{ formatTime(duration) }}</span>
        </div>


        <div class="audio-controlls d-flex">
            <!-- <button (click)="prevTrack()">
                <img src="./assets/images/icons/ic_previous.svg" alt="ic_previous">
            </button> -->
            <button (click)="togglePlay()" id="play-pause">
                <img *ngIf="!isPlaying" src="./assets/images/icons/play_audio.svg" alt="play_audio">
                <img *ngIf="isPlaying" src="./assets/images/icons/pause_audio.svg" alt="pause_audio">
            </button>
            <!-- <button (click)="nextTrack()">
                <img src="./assets/images/icons/ic_next.svg" alt="ic_next">
            </button> -->
        </div>
    </div>




</div>


<audio #audioElement *ngIf="audioSrc" (timeupdate)="updateProgress()" (loadedmetadata)="loadMetadata()">
    <source [src]="audioSrc" type="audio/mp3">
    Your browser does not support the audio element.
</audio>